import HTTP from '../HTTP';

const URL_BASE = 'gescom/Import/';

export async function importIdeliaCommandeAsync(payload) {
  const response = await HTTP.post(URL_BASE + 'ImportCommandeAsync', payload);
  return response;
}

export const NOTHING = null;
